export var currencyInputUtils = {
    numberToString: function (value) {
        return value.toLocaleString().replace(/\,/g, '.');
    },
    stringToNumber: function (value) {
        return parseInt(value.replace(/\./g, ''), 10);
    },
};
